
import DashboardHeader from "./DashboardHeader.vue";
import DashboardFooter from "./DashboardFooter.vue";
import ImapList from "./ImapList.vue";
import ArticlesTable from "./ArticlesTable.vue";
import CampaignTable from "./CampaignTable.vue";
import ClientImagesTable from "./ClientImagesTable.vue";
import ClientPagesTable from "./ClientPagesTable.vue";
import DefaultPicUpload from "./DefaultPicUpload.vue";
import MissingLinkTable from "./MissingLinkTable.vue";
import SearchLocation from "./SearchLocation.vue";
import SearchResultTable from "./SearchResultTable.vue";
import SearchPositionTable from "./SearchPositionTable.vue";
import SocialTable from "./SocialTable.vue";
import QuestionnaireTable from "./QuestionnaireTable.vue";
import WebLLCRESTApi from "../api/api";
import AuthToken from "../api/authtoken";
import StatesUtil from "../util/states";
import AuditLog from "./AuditLog.vue";
import AlertDlg from "./AlertDlg.vue";
import SelectUserDlg from "./SelectUserDlg.vue";
import $ from "jquery";

export default {
  async created() {
    this.api = new WebLLCRESTApi("Clients", this.$router);
    this.campaignApi = new WebLLCRESTApi("Campaigns", this.$router);
    this.authBasicUsersApi = new WebLLCRESTApi("Auth-Basic-Users", this.$router);
    this.clientLocationsApi = new WebLLCRESTApi("Client-Locations", this.$router);
    
    const usersApi = new WebLLCRESTApi("Users", this.$router);
    this.ownerList = await usersApi.getData(null, { order: ["firstName ASC", "lastName ASC"] });
    
    if(this.$route.params.id == "new") {
      const loggedInUser = JSON.parse(localStorage.getItem('user'));
      this.cmbOwner = (loggedInUser.role != "basic" ? loggedInUser.username : "");
      this.cmbAuthUser = (loggedInUser.role == "basic" ? loggedInUser.username : "");
      
      this.canSave = true;
      this.editing = true;
    }
    else {
      // load client details from API
      this.refreshFromAPI(this.$route.params.id);
    }
  },
  
  data() {
    return {
      selectedTab: "campaigns",
      editing: false,
      isIdURLOK: true,
      isDuplicateClient: false,
      duplicateClientURL: "",
      chkDisplayName: false,
      txtDisplayName: "",
      cmbTitle: "NA",
      txtFirstName: "",
      txtLastName: "",
      chkActive: true,
      txtAbout: "",
      cmbOwner: "",
      searchLocations: [],
      authBasicUsers: [],
      txtAuthBasicUsers: "",
      cmbAutoReport: "false",
      canSave: true,
      ownerList: [],
      jobInfo: {
        ready: 0,
        scheduled: 0,
        failed: 0
      },
      states: StatesUtil.getAllStates(),
      auditLog: [],
      auditLogLoading: false,
      createdBy: "",
      updatedBy: "",
      createdAt: new Date(),
      updatedAt: new Date(),
      hasLongAboutMe: false,
      autoCriteriaMet: true,
      hasErrors: false,
      errorFields: {},
      
      lostAccessMessage: ["You have not selected yourself as account manager or assistant. Proceeding will disable your access for this client."],
      lostAccessButtons: [
        {
          name: "cancel",
          text: "Cancel"
        },
        {
          name: "ok",
          text: "Proceed Anyway"
        }
      ],
      
      authToken: AuthToken.getAuthObject()
    };
  },
  
  methods: {
    async refreshFromAPI(clientId) {
      var data = await this.api.getData(clientId, { include: [ "authBasicUsers", "clientLocations" ] });
      
      this.chkDisplayName = !!data.displayName;
      this.txtDisplayName = data.displayName;
      this.cmbTitle = data.title;
      this.txtFirstName = data.firstName;
      this.txtLastName = data.lastName;
      this.chkActive = (data.status == "active");
      this.txtAbout = data.aboutMe;
      this.createdBy = data.createdBy;
      this.updatedBy = data.updatedBy;
      this.createdAt = new Date(data.createdAt);
      this.updatedAt = new Date(data.updatedAt);
      this.cmbOwner = data.owner;
      this.searchLocationId = { id: data.searchLocationId };
      this.cmbAutoReport = data.autoReport.toString();
      
      this.authBasicUsers = (data.authBasicUsers ? data.authBasicUsers.map(this.getUserFromCache.bind(this)) : []);
      this.searchLocations = (data.clientLocations ? data.clientLocations : []);
      
      this.canSave = (this.authToken ?
        this.authToken.role == "admin" || this.authToken.username == data.owner || this.authBasicUsers.filter((authBasicUser) => authBasicUser.username == this.authToken.username).length > 0 :
        false);
    },
    
    getUserData(id){
      return 'admin'
    },
    
    editInfo() {
      this.editing = true;
    },
    
    checkRequiredFields() {
      var isOk = true;
      
      const fieldList = [
        { field: this.txtFirstName, name: "txtFirstName" },
        { field: this.txtLastName, name: "txtLastName" },
        { field: this.cmbOwner, name: "cmbOwner" }
      ];
      
      this.errorFields = {};
      
      for(var index=0; index<fieldList.length; index++) {
        const entry = fieldList[index];
        
        if(!entry.field) {
          this.errorFields[entry.name] = "is-invalid";
          isOk = false;
        }
      }
      
      return isOk;
    },
    
    saveInfo() {
      return this.performSave(true);
    },
    
    lostAccessSelected(button) {
      if(button == "ok") {
        return this.performSave(false);
      }
    },
    
    async performSave(checkAccess) {
      const authToken = AuthToken.getAuthObject();
      
      // --- Checks
      if(!this.checkRequiredFields() || this.hasLongAboutMe) {
        this.hasErrors = true;
        return false;
      }
      
      if(checkAccess && this.willLoseAccess(authToken)) {
        $('#dlg-lose-access').modal('toggle');
        return false;
      }
      
      this.autoCriteriaMet = await this.checkAutoCriteriaMet();
      if(!this.autoCriteriaMet) {
        return false;
      }
      
      // --- Checks Passed
      this.hasErrors = false;

      var clientObj = {
        "displayName": (this.chkDisplayName ? this.txtDisplayName.trim() : ""),
        "title": this.cmbTitle,
        "firstName": this.txtFirstName.trim(),
        "lastName": this.txtLastName.trim(),
        "status": (this.chkActive ? "active" : "inactive"),
        "aboutMe": this.txtAbout.trim(),
        "owner": this.cmbOwner,
        "authBasicUser": this.cmbAuthUser,
        "autoReport": this.cmbAutoReport == "true"
      };
      
      // push the changes to the database
      const res = await (() => {
        if(this.$route.params.id == "new") {
          return this.api.addData(clientObj);
        }
        else {
          return this.api.updateData(this.$route.params.id, clientObj);
        }
      })();
      
      if(res.status == 200 || res.status == 204) {
        const updatedId = res.status == 200 ? (await res.json()).id : this.$route.params.id;
        
        // update the date on the right
        this.updatedAt = new Date();
        
        // make sure the assistants are saved
        await this.updateAuthBasicUsersToApi(updatedId, this.authBasicUsers.map((userInfo) => userInfo.username));
        
        // make sure the locations are saved
        await this.updateClientLocationsToApi(updatedId, this.searchLocations);
        
        // refresh whether we can save this record
        this.canSave = (authToken ?
          authToken.role == "admin" || authToken.username == clientObj.owner || authToken.username == clientObj.authBasicUser :
          false);
        
        // if the zoho id has changed (new items) we need to update the route
        if(this.$route.params.id !== updatedId) {
          this.$router.replace("/client/" + updatedId);
          this.editing = false;
        }
        else {
          this.editing = false;
        }
      }
      else if(res.status == 500) {
        alert("Internal server error");
      }
      else if(res.status == 422) {
        const errorInfo = await res.json();
        alert(errorInfo.error.message);
      }
      else if(res.status == 401) {
        alert("Unauthorized. Did your login session expire?");
      }
      else {
        alert("Unknown error");
      }
    },
    
    selectAuthBasicUsers() {
      $('#modal-select-temp-users').modal('toggle');
    },
    
    getUserFromCache(user) {
      const username = (user.authUsername ? user.authUsername : user);
      
      const defaultUserInfo = {
        id: "",
        username: username,
        firstName: "Not",
        lastName: "Found (" + username + ")",
        role: "admin"
      };
      
      return this.ownerList.reduce((current, owner) => {
        if(owner.username == username) {
          return owner;
        }
        else {
          return current;
        }
      }, defaultUserInfo);
    },
    
    setNewAuthBasicUsers(newBasicUserList) {
      this.authBasicUsers = newBasicUserList.map(this.getUserFromCache.bind(this));
    },
    
    async updateAuthBasicUsersToApi(clientId, newBasicUserList) {
      const currentBasicUsers = await this.authBasicUsersApi.getData(null, {
        where: {
          clientId: clientId
        }
      });
      
      const missingUsers = newBasicUserList.filter((user) => currentBasicUsers.filter((authBasicUser) => authBasicUser.authUsername == user).length == 0);
      const extraUsersWithTableId = currentBasicUsers.filter((authBasicUser) => newBasicUserList.indexOf(authBasicUser.authUsername) === -1);
      
      const promises = [];
      
      for(const missingUser of missingUsers) {
        promises.push(this.authBasicUsersApi.addData({
          clientId: clientId,
          authUsername: missingUser
        }));
      }
      
      for(const extraUser of extraUsersWithTableId) {
        promises.push(this.authBasicUsersApi.deleteData(extraUser.id));
      }
      
      return await Promise.all(promises);
    },
    
    async updateClientLocationsToApi(clientId, newSearchLocations) {
      const currentSearchLocations = await this.clientLocationsApi.getData(null, {
        where: {
          clientId: clientId
        }
      });
      
      const fnLocationMatches = (a, b) => {
        return a.country == b.country &&
          a.state == b.state &&
          a.city == b.city;
      };
      
      const missingLocations = newSearchLocations.filter((location) => currentSearchLocations.filter((curLocation) => fnLocationMatches(location, curLocation)).length == 0);
      const extraLocations = currentSearchLocations.filter((curLocation) => newSearchLocations.filter((location) => fnLocationMatches(location, curLocation)).length == 0);
      
      const promises = [];
      
      for(const missingLocation of missingLocations) {
        promises.push(this.clientLocationsApi.addData({
          country: missingLocation.country,
          state: missingLocation.state,
          city: missingLocation.city,
          clientId: clientId,
        }));
      }
      
      for(const extraLocation of extraLocations) {
        promises.push(this.clientLocationsApi.deleteData(extraLocation.id));
      }
      
      return await Promise.all(promises);
    },
    
    willLoseAccess(authToken) {
      return (this.cmbOwner != authToken.username && this.authBasicUsers.filter((basicUser) => basicUser.username === authToken.username).length == 0 && authToken.role != "admin");
    },
    
    selectTab(newTab) {
      this.selectedTab = newTab;
    },
    
    async checkAutoCriteriaMet() {
      if(this.cmbAutoReport === "true") {
        // location must be filled down to city level
        if(this.searchLocations.length > 0) {
          // all search locations must have a city filled
          for(const searchLocation of this.searchLocations) {
            if(searchLocation.city === 0 || searchLocation.city === undefined) {
              return false;
            }
          }
          
          // we must have an active campaign with keywords filled out
          const campaigns = await (this.$route.params.id == "new" ?
            [] :
            this.campaignApi.getData(null, {
              where: {
                clientId: this.$route.params.id
              }
            }));
          
          for(const campaign of campaigns) {
            const data = (campaign.data ? JSON.parse(campaign.data) : {});
            
            if(data.keywords && data.keywords.length > 0) {
              return true;
            }
          }
          
          return false;
        }
        else {
          return false;
        }
      }
      else {
        return true;
      }
    }
    
  },
  
  components: {
    DashboardHeader,
    DashboardFooter,
    ImapList,
    ArticlesTable,
    CampaignTable,
    ClientImagesTable,
    ClientPagesTable,
    DefaultPicUpload,
    MissingLinkTable,
    SearchLocation,
    SearchResultTable,
    SearchPositionTable,
    SocialTable,
    QuestionnaireTable,
    AuditLog,
    AlertDlg,
    SelectUserDlg
  },
  
  watch: {
    $route(to, from) {
      // check if the client/zoho id has changed
      if(to.params.id !== from.params.id) {
        this.refreshFromAPI(to.params.id);
      }
    },
    
    authBasicUsers(to) {
      this.txtAuthBasicUsers = to.map((user) => user.firstName + " " + user.lastName).join(", ");
    },
    
    txtAbout(to) {
      this.hasLongAboutMe = to && to.length > 65535;
    },
    
    async searchLocationId(to) {
      this.autoCriteriaMet = await this.checkAutoCriteriaMet();
    }
  },
  
  computed: {
    
    basicUsers() {
      return this.ownerList.filter((user) => user.role == "basic");
    }
  },
}



// WEBPACK FOOTER //
// ./src/components/ClientView.js